import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { TriggerWrapper } from './wshComponents'
import { getRouteContent } from '@src/constants/helpContent'
import { useTour } from '@src/hooks/useTour'
import { useAuth } from '@src/context/AuthContext'
import { useSupport } from '@src/context/SupportModalContext'
import { IS_DEMO } from '@src/constants/env'
import WshTourButton from './WshTourButton'

const WshHelpTrigger: React.FC = () => {
  const { pathname } = useLocation()
  const { runTour, hasSeen } = useTour()
  const { isAuthenticated } = useAuth()
  const { openSupport } = useSupport()

  // Auto-run tour once per session per route in demo mode (except /products — gate modal owns that page);
  // first visit only (localStorage) otherwise
  useEffect(() => {
    if (IS_DEMO && pathname === '/products' && !isAuthenticated) return
    const content = getRouteContent(pathname)
    if (!content) return
    const demoKey = `demo_tour_seen_${pathname}`
    const hasSeenThisSession = IS_DEMO ? sessionStorage.getItem(demoKey) === 'true' : false
    if ((!IS_DEMO && !hasSeen(pathname)) || (IS_DEMO && !hasSeenThisSession)) {
      const t = setTimeout(() => {
        if (document.querySelector('.modal.show')) return
        if (IS_DEMO) sessionStorage.setItem(demoKey, 'true')
        runTour(content, pathname, IS_DEMO, isAuthenticated, openSupport)
      }, 600)
      return () => clearTimeout(t)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, isAuthenticated])

  const content = getRouteContent(pathname)
  if (!content) return null

  return (
    <TriggerWrapper>
      <WshTourButton
        onClick={() => runTour(content, pathname, IS_DEMO, isAuthenticated, openSupport)}
      />
    </TriggerWrapper>
  )
}

export default WshHelpTrigger
